require('./_wks-define')('observable');



//////////////////
// WEBPACK FOOTER
// D:/发行部门文件/后台管理系统文件/~/core-js/modules/es7.symbol.observable.js
// module id = 492
// module chunks = 0